var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from "react";
import styled from "styled-components";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import Typography from "@material-ui/core/Typography";
import "likert-react/dist/main.css";
import PeerReviewForm from "./PeerReviewForm";
import PeerReviewsGuidance from "./PeerReviewsGuidance";
import ReceivedPeerReviewsInfo from "./ReceivedPeerReviewsInfo";
import * as peerReviewsActions from "../../state/peerReviews/actions";
import Togglable from "../../utils/Togglable";
import { useTypedSelector } from "../../state/store";
import { BoldTypography } from "../styleComponents";
var TopMarginDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 15px;\n"], ["\n  margin-top: 15px;\n"])));

var PeerReviews = function PeerReviews() {
  var dispatch = useDispatch();
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });

  if (!quiz) {
    return React.createElement("div", null);
  }

  var activeStep = useTypedSelector(function (state) {
    return state.peerReviews.activeStep;
  });
  var pastDeadline = useTypedSelector(function (state) {
    return state.quizAnswer.pastDeadline;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var peerReviewQuestions = quiz.peerReviewCollections;
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });

  if (!languageInfo) {
    return React.createElement("div", null);
  }

  if (quizDisabled) {
    return React.createElement(Typography, {
      variant: "subtitle1"
    }, languageInfo.peerReviews.peerReviewsInfoForLoggedOutUser);
  }

  var peerReviewsLabels = languageInfo.peerReviews;
  var giveExtraPeerReviewsLabel = activeStep >= 3 ? peerReviewsLabels.giveExtraPeerReviewsQuizConfirmed : peerReviewsLabels.giveExtraPeerReviews;
  useEffect(function () {
    dispatch(peerReviewsActions.fetchPeerReviewAlternatives());
  }, []);

  var morePeerReviewsRequired = function morePeerReviewsRequired() {
    return (userQuizState ? userQuizState.peerReviewsGiven : 0) < quiz.course.minPeerReviewsGiven;
  };

  if (peerReviewQuestions.length === 0) {
    return React.createElement(Typography, {
      variant: "subtitle1"
    }, peerReviewsLabels.quizInvolvesNoPeerReviewsInstruction);
  }

  return React.createElement("div", null, activeStep >= 2 && React.createElement(ReceivedPeerReviewsInfo, null), morePeerReviewsRequired() ? !pastDeadline && React.createElement(React.Fragment, null, React.createElement(PeerReviewsGuidance, {
    guidanceText: peerReviewQuestions[0].texts[0].body,
    givenLabel: peerReviewsLabels.givenPeerReviewsLabel,
    peerReviewsCompletedInfo: peerReviewsLabels.peerReviewsCompletedInfo
  }), React.createElement(PeerReviewForm, {
    languageInfo: peerReviewsLabels
  })) : !pastDeadline && React.createElement(React.Fragment, null, React.createElement(BoldTypography, {
    variant: "subtitle1"
  }, giveExtraPeerReviewsLabel), React.createElement(Togglable, {
    initiallyVisible: activeStep === 1,
    hideButtonText: peerReviewsLabels.hidePeerReviewLabel,
    displayButtonText: peerReviewsLabels.displayPeerReview
  }, React.createElement(TopMarginDiv, null, React.createElement(PeerReviewsGuidance, {
    guidanceText: peerReviewQuestions[0].texts[0].body,
    givenLabel: peerReviewsLabels.givenPeerReviewsLabel,
    peerReviewsCompletedInfo: peerReviewsLabels.peerReviewsCompletedInfo
  }), React.createElement(PeerReviewForm, {
    languageInfo: peerReviewsLabels
  })))));
};

export default PeerReviews;
var templateObject_1;